import { render, staticRenderFns } from "./ApplicantTabsContainer.vue?vue&type=template&id=a49f2e54&scoped=true"
import script from "./ApplicantTabsContainer.vue?vue&type=script&lang=js"
export * from "./ApplicantTabsContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a49f2e54",
  null
  
)

export default component.exports